
/*import React from "react";
import logo from "./logo.svg";
import "./App.css";
import axios from "axios";

function App() {
  const [data, setData] = React.useState(null);

  React.useEffect(() => {
    axios("/status")
     .then((res) => setData(res.data.message))
     .catch((err) => setData(err.response.data.message));
  }, []);

  return (
    <div className="App">

      <header className="App-header">
        <img src={logo} className="App-logo" alt="logo" />
        <p>{!data ? "Waiting for server..." : data}</p>
      </header>

    </div>
  );

}

export default App;*/

import * as React from 'react';
import Container from '@mui/material/Container';
import Typography from '@mui/material/Typography';
import Box from '@mui/material/Box';
import ResponsiveDrawer from './Nav';

export default function App() {
  return (
    //<Box sx={{ my: 4 }}>
      <ResponsiveDrawer />
    //</Box>
  );
}

